import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Layout from "../components/layout/Layout";
import Brand1 from "../components/sections/Brand1";
import ContactInfo from "../components/sections/contact/ContactInfo";
import ContactInfo2 from "../components/sections/contact/ContactInfo2";
import ContactSection from "../components/sections/contact/ContactSection";

export default function Contact() {
  useEffect(() => {
    // Prevent double initialization if fbq is already present
    if (window.fbq) return;

    // Create the Meta Pixel inline script (exactly the same logic as your snippet)
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1367360947588739');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);

    // Add noscript fallback (image pixel) to the document body
    const noscriptEl = document.createElement("noscript");
    noscriptEl.innerHTML = '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1367360947588739&ev=PageView&noscript=1" />';
    document.body.appendChild(noscriptEl);

    // Cleanup on unmount
    return () => {
      // remove injected script and noscript
      if (script && script.parentNode) script.parentNode.removeChild(script);
      if (noscriptEl && noscriptEl.parentNode) noscriptEl.parentNode.removeChild(noscriptEl);

      // Optionally: remove fbq to fully clean global (use with caution if other pages rely on it)
      try {
        if (window.fbq && typeof window.fbq === "function") {
          // empty call queue and remove reference
          window.fbq = undefined;
        }
      } catch (e) {
        // ignore
      }
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>V-Make | Contact Us</title>
        <meta name="description" content="Get in touch with V-Make for premium WPC doors, frames, and boards. We're here to assist you with product inquiries, distribution partnerships, or custom solutions." />
        <meta name="keywords" content="contact V-Make, WPC doors support, WPC frames inquiry, dealer contact, WPC board information, get in touch V-Make, V-Make contact details, customer support WPC" />
        <link rel="canonical" href="https://vmakewpc.com/contact" />
        <meta property="og:title" content="Contact Us | V-Make WPC" />
        <meta property="og:description" content="Need help or more information about V-Make’s WPC products? Reach out to our support and sales team today." />
        <meta property="og:url" content="https://vmakewpc.com/contact" />
        <meta
          property="og:image"
          content="https://www.google.com/maps/place/V+MAKE+INDUSTRIES/@12.787585,77.739029,12z/data=!4m6!3m5!1s0x3bae71e8fcc5626d:0xaff1c81a29ca91a!8m2!3d12.787585!4d77.7390285!16s%2Fg%2F11vy5p60z0?hl=en&entry=ttu&g_ep=EgoyMDI1MDUyNi4wIKXMDSoASAFQAw%3D%3D"
        />
        <meta property="og:type" content="website" />
        <meta property="og:updated_time" content="2024-12-02T00:00:00+00:00" />
        <meta property="article:modified_time" content="2024-12-02T00:00:00+00:00" />
      </Helmet>

      <Layout headerStyle={1} footerStyle={1} breadcrumbTitle="Contact Us">
        <ContactInfo />
        <ContactSection />
        <ContactInfo2 />
        {/* <Brand1 /> */}
      </Layout>
    </>
  );
}
